module.exports = __webpack_public_path__ + "img/qijian-xiaopiao.e41bc88f.svg";